export const MODULE_GUID = {
  POST: "9a115da2-ad57-4dcd-9b23-c3e73474f90f",
  APPLICATION: "e6cf355f-2089-4bb2-8576-d391f9664fd7",
  PAYMENT: "603fc12e-eb4e-43dc-897c-10757cf56c81",
  BROADCAST: "3c089ea6-85cf-4817-830c-c95ecf66b762",
  SETUP: "189489d6-9b01-4f32-a84d-63f91e938c28",
  SECURITY: "a60f275a-e645-48f7-b4a9-899c1b233e6c",
  INQUIRY: "72f90891-85d1-48e2-8643-09584891be9a",
  ABOUT_US: "3be8812a-ef61-4d7c-b86b-b36d7a494dde",
}

export const EVENT_STATUS_GUID = {
  OPENED: "f508ffa8-4d7d-474c-9129-62511f50cfef",
  CLOSED: "6136186e-e722-4da3-bf58-19e72a7337cd",
  VOIDED: "d51d872a-ce6d-4c3e-84c3-1ea88b5a63f6",
  NEW: "e784e4a7-3da6-4da0-859b-6862033cab6c",
  ENDED: "340bc442-3e65-4ee8-8fa6-6c3f51528b71",
  POSTED: "382acc44-82ca-4984-bdd7-f401cdd6b6e2",
}

export const ACTIVITY_PAYMENT_STATUS_GUID = {
  SUBMITTED: "74bcade9-47e7-42e9-937f-ae5ae87f3f75",
  INVALID: "5ef5653a-860e-4bc4-a980-3db0dc73e698",
  PAID: "ee8fcffe-07ff-4891-9d7a-052e1af71804",
  REFUNDED: "0e108258-6708-4835-9677-27d48c10adb5",
  PAID_WHEN_CREATED: "78e91435-e84c-4431-914b-597d9aaca53c",
  VOIDED: "e39f496f-5c8a-4240-8e67-994dc4f32131",
  PENDING_REFUND: "41f75670-05a2-42a7-af33-fd5ddfb0499c",
  PENDING: "b956716a-cd2f-432b-872a-d2aa63fe3e15",
}

export const APPLICATION_STATUS_GUID = {
  EXPIRED: "08062635-ca22-40a6-bd76-3bb584c9704e",
  DRAFT: "12423752-9511-4327-9687-4a558910cec8",
  APPROVED: "e80a6d8a-7472-4079-b919-7f3ea610e91c",
  REJECTED: "839b98a9-b017-463a-b58b-923720d19b3c",
  PENDING: "9614fb10-e037-4b38-bff7-a351855c6be3",
  KIV: "37f0b75f-ad57-400f-9b87-c4fa14cc5fce",
}

export const ACTION = {
  SUBMIT: "Submit",
  CLONE: "Clone",
  DELETE: "Delete",
  UPDATE_STATUS: "Update Status",

  KIV: "KIV",
  REJECT: "Reject",
  RESET: "Reset",

  VERIFY: "Verify",
  VOID: "Void",
  INVALID: "Invalid",
  REFUNDED: "Refunded"
}

export const QUESTION_TYPE = {
  SINGLE_ANSWER: "Single Answer",
  MULTI_OPTION_SINGLE_CHOICE: "Multi-Option & Single Choice",
  MULTI_OPTION_MULTI_CHOICE: "Multi-Option & Multi-Choice",
}

export const LANGUAGES = [
  {
    name: '简体中文',
    code: 'zh-CN',
  },
  {
    name: '繁体中文',
    code: 'zh-TW',
  },
  {
    name: 'English',
    code: 'en',
  },
]

export const PAYMENT_TERM = {
  PREPAYMENT: 1,
  POSTPAYMENT: 2
}

export const PAYMENT_TERMS = [
  {
    value: PAYMENT_TERM.PREPAYMENT,
    label: 'Pre-Payment',
    description: 'Applicant make payment before admin accept application',
  },
  {
    value: PAYMENT_TERM.POSTPAYMENT,
    label: 'Post-Payment',
    description: 'Applicant make payment after admin accept application',
  },
]

export const BANKS = [
  "Affin Bank",
  "Agrobank",
  "Alliance Bank",
  "Ambank",
  "Bank Islam",
  "Bank Muamalat",
  "Bank Rakyat",
  "Bank Simpanan Nasional (BSN)",
  "CIMB Bank",
  "Citibank Malaysia",
  "Hong Leong Bank",
  "HSBC Bank Malaysia",
  "Maybank",
  "OCBC Bank",
  "Public Bank",
  "RHB Bank",
  "Standard Chartered Bank",
  "United Overseas Bank (UOB)"
]
